import * as React from 'react';

import { PK } from 'common/types';

import { useSaveMinisBlog } from '../hooks';
import { useMiniDetails } from 'modules/minis/queries';
import BlogsPicker from './BlogsPicker';

type Props = {
  pk?: PK;
};

const MinisBlogPicker = ({ pk }: Props) => {
  const { data } = useMiniDetails(pk);
  const blog_pk = data?.blog_pk;
  const { save, isLoading, isError, isSuccess } = useSaveMinisBlog(pk);
  const saveStatus = { isLoading, isError, isSuccess };

  return <BlogsPicker pk={pk} blog_pk={blog_pk} onSave={save} saveStatus={saveStatus} />;
};

export default MinisBlogPicker;
